const canvasObjPosition  = (obj, parent, x, y)=>{
    obj.anchor.set(0.5, 0);
    obj.x = x;
    obj.y = y ;
    parent.addChild(obj);
    return;
}

export default canvasObjPosition;